




















































































































import Vue from "vue";
import Component from "vue-class-component";
import { graphqlClient } from "@/utils/graphql";
import { FileCategory } from "@/models/queries/FileCategoriesQuery";
import { namespace } from "vuex-class";
import vue2Dropzone from "vue2-dropzone";
import { Watch } from "vue-property-decorator";
import LoadingButton from "@/components/core/controls/loading-button.component.vue";
import { UploadFile, UploadFileVariables } from "@/models/mutations/types/UploadFile";
import { UPLOAD_FILE_MUTATION } from "@/models/mutations/UploadFileMutation";
import { UploadFileResponse } from "@/models/graphql-global-types";
import { CompanyStore } from "@/store/CompanyStore";
import { Company } from "@/models/queries/AvailableCompaniesQuery";
import { UserService } from "@/services/UserService";

const fileStore = namespace("fileStore");

@Component({
  components: {
    vueDropzone: vue2Dropzone,
    LoadingButton
  }
})
export default class FileUpload extends Vue {
  @fileStore.State("fileCategories") fileCategories;
  private selectedFileCategory: FileCategory | null = null;
  private fileName: string | null = null;
  private selectedFile: File | null = null;
  private isUploading: Boolean = false;
  private selectedCompany: Company | null | undefined = null;

  private onFileChanged(e) {
    const file = e.target.files[0];
    console.log(file);
  }

  private getDropzoneOptions() {
    return {
      url: "url",
      maxFiles: 1,
      thumbnailWidth: 50,
      dictDefaultMessage: this.$t("file_upload.dropzone.text"),
      accept: this.acceptFile,
      createImageThumbnails: false
    };
  }

  private clearFile() {
    this.clearDropZone();
    this.selectedFile = null;
  }

  private acceptFile(file: File) {
    const fileType = file.name.substring(file.name.lastIndexOf("."), file.name.length);

    if (this.selectedFileCategory && !this.selectedFileCategory.allowedFileTypes.includes(fileType)) {
      this.clearDropZone();
      this.$notify({
        title: this.$t("general.error.error") as string,
        text: this.$t("file_upload.dropzone.wrong_file_type") as string,
        type: "error"
      });
    } else {
      this.fileName = file.name.substring(0, file.name.lastIndexOf("."));
      this.selectedFile = file;
    }
  }

  private clearDropZone() {
    const dropzone = this.$refs.myVueDropzone as any;
    if (dropzone) {
      dropzone.removeAllFiles(true);
    }
  }

  @Watch("selectedFileCategory")
  private onSelectedFileCategoryChanged(val: FileCategory | null, oldVal: FileCategory | null) {
    this.clearDropZone();
  }

  private showError() {
    this.$notify({
      title: this.$t("general.error.error") as string,
      text: this.$t("file_upload.saving.error") as string,
      type: "error"
    });
  }

  get companies() {
    return CompanyStore.availableCompanies;
  }

  @Watch("companies")
  private watchCompanies() {
    this.tryToSelectCompany();
  }

  private tryToSelectCompany() {
    if (this.companies.length === 1) {
      this.selectedCompany = this.companies[0];
    } else {
      const user = UserService.user;
      this.selectedCompany = this.companies.find(c => c.shortcut === user?.company);
    }
  }

  public mounted() {
    this.tryToSelectCompany();
  }

  private uploadFile() {
    this.$validator.validateAll().then(valid => {
      if (valid && this.selectedFile) {
        const extension =
          this.selectedFile &&
          this.selectedFile.name.substring(this.selectedFile.name.lastIndexOf("."), this.selectedFile.name.length);
        console.log(extension);
        this.isUploading = true;
        graphqlClient
          .mutate<UploadFile, UploadFileVariables>({
            mutation: UPLOAD_FILE_MUTATION,
            variables: {
              file: this.selectedFile,
              fileCategoryId: (this.selectedFileCategory && this.selectedFileCategory.id) || "",
              fileName: this.fileName + extension || "",
              companyId: this.selectedCompany?.shortcut ?? ""
            }
          })
          .then(result => {
            this.isUploading = false;
            if (result && result.data && result.data.uploadFile === UploadFileResponse.SUCCESS) {
              this.$notify({
                title: this.$t("general.success") as string,
                text: this.$t("file_upload.saving.success") as string,
                type: "success"
              });

              this.$router.push("/files/overview");
            } else if (result && result.data && result.data.uploadFile === UploadFileResponse.FILE_EXISTS) {
              this.$notify({
                title: this.$t("general.error.error") as string,
                text: this.$t("file_upload.saving.file_exists") as string,
                type: "warn"
              });
            } else {
              this.showError();
            }
          })
          .catch(error => {
            console.error(error);
            this.isUploading = false;
            this.showError();
          });
      }
    });
  }
}
